import '../styles/RequestBillListStyle.css';
import { useCallback, useEffect, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { MdCancel } from 'react-icons/md';
import { AiOutlineRedo } from 'react-icons/ai';
import { RPURequestStatusType } from '../../models/types/RPURequestStatusType';
import { BsFiletypeCsv } from 'react-icons/bs';
import Spinner from 'react-bootstrap/Spinner';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Batu } from '../../batu/interface/Batu';
import { useActions, useTypedSelector } from '../../hooks';
import { Modal } from 'react-bootstrap';
import { FormButton, BaseInput, ControlledNumericInput } from '../common';
import { HiOutlineDocumentDuplicate } from 'react-icons/hi2';
import { IoIosTimer } from 'react-icons/io';
import { LiaFileDownloadSolid } from 'react-icons/lia';
import { BiMessageRoundedError } from 'react-icons/bi';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useIntercom } from 'react-use-intercom';
import { AuthSession, fetchAuthSession } from 'aws-amplify/auth';

const ORGANIZAION_NOT_REGISTERED = 'organization is not registered';
const SERVICE_NAME_NOT_AVALABLE = 'service name not available for rpu';
const RPU_NO_LONGER_AVALABLE = 'rpu no longer available';
const CONTRACT_DATA_NOT_AVALABLE =
  'El sitio de datos del contrato no está disponible, intenta nuevamente en unos minutos.';
const LATEST_TOTAL_INCORRECT =
  'Necesitamos el monto del último recibo para registrarlo, intenta nuevamente para agregarlo.';
const SERVICE_NAME_INCORRECT = 'Service name is incorrect';

interface RequestedBillProps {
  batu: Batu;
}
const RequestedBill: React.FC<RequestedBillProps> = ({ batu }) => {
  const { isOpen, showNewMessage } = useIntercom();
  const [status, setStatus] = useState<RPURequestStatusType>(
    batu.status ?? RPURequestStatusType.IN_PROCESS
  );
  const [needsCFECredentialLocalFlag, setneedsCFECredentialLocalFlag] =
    useState(false);
  const [variableErrors, setVariableErrors] = useState(['']);
  const [serviceNameErrorMessage, setServiceNameErrorMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState(batu.errorMessage ?? '');
  const [progress, setProgress] = useState(batu.progress ?? 0);
  const [csvLink, setCsvLink] = useState(batu.csvLink ?? '');
  const [pdfLink, setPdfLink] = useState(batu.pdfLink ?? '');
  const [jsonResponse, setJsonResponse] = useState<any>(null);
  const [recoveredBills, setRecoveredBills] = useState(
    batu.recoveredBills ?? 0
  );
  const [timeElapsed, setTimeElapsed] = useState(batu.timeElapsed ?? 0);
  const [showServiceNameModal, setShowServiceNameModal] = useState(false);
  const [serviceName, setServiceName] = useState(batu.serviceName ?? '');
  const [latestTotal, setLatestTotal] = useState(batu.latestTotal ?? 0);
  const dontRemindUserCFECredentials = useTypedSelector(({ ui }) => {
    return ui.dontRemindUserCFECredentials;
  });
  const surveyEmail = useTypedSelector(({ uxSurvey }) => {
    return uxSurvey.surveyEmail;
  });
  const { updateSurveyEmail, userNeedsCfeCredentials, userNeedsRegistration } =
    useActions();
  useEffect(() => {
    if (
      needsCFECredentialLocalFlag &&
      !dontRemindUserCFECredentials &&
      jsonResponse !== null &&
      jsonResponse[0] &&
      jsonResponse[0].billRate === 'GDMTH'
    ) {
      userNeedsCfeCredentials(true);
    }
  }, [
    userNeedsCfeCredentials,
    needsCFECredentialLocalFlag,
    dontRemindUserCFECredentials,
    jsonResponse,
  ]);
  const onProgress = useCallback((event: CustomEvent) => {
    let _progress = event.detail;
    setProgress(_progress);
    if (
      _progress >= 5 &&
      surveyEmail === '' &&
      batu.email &&
      batu.email !== ''
    ) {
      updateSurveyEmail(batu.email);
    }
  }, []);
  const onStatus = useCallback((event: CustomEvent) => {
    let _status = event.detail as RPURequestStatusType;
    setStatus(_status);
  }, []);
  const onCfeCredentials = useCallback(() => {
    setneedsCFECredentialLocalFlag(true);
  }, []);
  const onResults = useCallback((event: CustomEvent) => {
    let _json = event.detail.json;
    let _csvLink = event.detail.csvLink;
    let _pdfLink = event.detail.pdfLink;
    let _timeElapsed = event.detail.timeElapsed;
    let _recoveredBills = event.detail.recoveredBills;
    setJsonResponse(_json);
    setCsvLink(_csvLink);
    setPdfLink(_pdfLink);
    setRecoveredBills(_recoveredBills);
    setTimeElapsed(_timeElapsed);
  }, []);
  const onError = useCallback(
    (event: CustomEvent) => {
      let _errorMsg = event.detail.errorMessage;
      if (_errorMsg === ORGANIZAION_NOT_REGISTERED) {
        userNeedsRegistration(true);
        return;
      }
      setErrorMessage(_errorMsg);
    },
    [userNeedsRegistration]
  );
  const onServiceName = useCallback((event: CustomEvent) => {
    let _serviceName = event.detail.serviceName;
    if (_serviceName !== '') {
      setServiceName(_serviceName);
      return;
    }
  }, []);
  useEffect(
    () => () => {
      const removeScannerEventListeners = () => {
        batu?.removeEventListener('progress', onProgress as EventListener);
        batu?.removeEventListener('status', onStatus as EventListener);
        batu?.removeEventListener('results', onResults as EventListener);
        batu?.removeEventListener('error', onError as EventListener);
        batu?.removeEventListener(
          'serviceName',
          onServiceName as EventListener
        );
        batu?.removeEventListener(
          'cfecredentials',
          onCfeCredentials as EventListener
        );
      };
      removeScannerEventListeners();
    },
    [
      batu,
      onProgress,
      onStatus,
      onResults,
      onError,
      onServiceName,
      onCfeCredentials,
    ]
  );
  useEffect(() => {
    if (batu) {
      batu?.addEventListener('progress', onProgress as EventListener);
      batu?.addEventListener('status', onStatus as EventListener);
      batu?.addEventListener('results', onResults as EventListener);
      batu?.addEventListener('error', onError as EventListener);
      batu?.addEventListener('serviceName', onServiceName as EventListener);
      batu?.addEventListener(
        'cfecredentials',
        onCfeCredentials as EventListener
      );
    }
  }, [
    batu,
    onProgress,
    onStatus,
    onResults,
    onError,
    onServiceName,
    onCfeCredentials,
  ]);
  const resetFeedback = () => {
    setVariableErrors(['']);
    setServiceNameErrorMessage('');
  };
  const requestBatu = async (serviceName?: string, latestTotal?: number) => {
    let token = await getSessionToken();
    batu.requestRpu(token, serviceName, latestTotal, true);
  };
  const getSessionToken = async () => {
    const sessionToken: string = await fetchAuthSession().then(
      (session: AuthSession) => {
        return session.tokens?.idToken?.toString() ?? '';
      }
    );
    return sessionToken;
  };
  const retryWithServiceName = async (requestServiceName: boolean) => {
    setVariableErrors(['']);
    setServiceNameErrorMessage('');
    if (requestServiceName && serviceName === '') {
      setServiceNameErrorMessage('Ingresa un nombre de servicio');
      setVariableErrors(['serviceName']);
      return;
    }
    setErrorMessage('');
    setStatus(RPURequestStatusType.IN_PROCESS);
    setJsonResponse(null);
    setCsvLink('');
    setProgress(0);
    setRecoveredBills(0);
    setTimeElapsed(0);
    let _serviceName = requestServiceName ? serviceName : '';
    let _latestTotal = latestTotal !== 0 ? latestTotal : undefined;
    requestBatu(_serviceName, _latestTotal);
    setShowServiceNameModal(false);
  };
  const retryError = () => {
    if (
      errorMessage === SERVICE_NAME_NOT_AVALABLE ||
      errorMessage === CONTRACT_DATA_NOT_AVALABLE ||
      errorMessage === LATEST_TOTAL_INCORRECT ||
      errorMessage === SERVICE_NAME_INCORRECT
    ) {
      setShowServiceNameModal(true);
    } else {
      setErrorMessage('');
      setStatus(RPURequestStatusType.IN_PROCESS);
      setJsonResponse(null);
      setCsvLink('');
      setProgress(0);
      setRecoveredBills(0);
      setTimeElapsed(0);
      requestBatu();
    }
  };
  const reportError = () => {
    if (!isOpen) {
      showNewMessage(
        `Hola, podrían ayudarme con un problema que tuve con el RPU ${batu.rpu}: ${errorMessage}?`
      );
    }
  };
  const getTimeElapsed = (timeElapsed: number) => {
    let seconds = timeElapsed;
    let minutes = Math.floor(seconds / 60);
    seconds = Math.ceil(seconds - minutes * 60);
    return `${minutes}m ${seconds}s`;
  };
  const renderStatus = (status: RPURequestStatusType) => {
    switch (status) {
      case RPURequestStatusType.SUCCESS:
        return <FaCheckCircle className="requested-bill-list-status success" />;
      case RPURequestStatusType.IN_PROCESS:
        return (
          <Spinner animation="grow" className="requested-bill-list-status" />
        );
      case RPURequestStatusType.ERROR:
        return <MdCancel className="requested-bill-list-status error" />;
      default:
        return (
          <Spinner animation="grow" className="requested-bill-list-status" />
        );
    }
  };
  const renderTooltip = (props: any) => (
    <Tooltip
      id="button-tooltip"
      className="request-bill-tootlip error"
      {...props}
    >
      {errorMessage}
    </Tooltip>
  );
  const renderInfoTooltip = (props: any) => (
    <Tooltip
      id="button-tooltip"
      className="request-bill-tootlip info"
      {...props}
    >
      Recuperamos {recoveredBills} archivos en {getTimeElapsed(timeElapsed)}
    </Tooltip>
  );
  const renderProgress = () => {
    if (errorMessage !== '') {
      return (
        <>
          <OverlayTrigger
            placement="top"
            delay={{ show: 50, hide: 400 }}
            overlay={renderTooltip}
          >
            <p className="requested-bill-item-error">{errorMessage}</p>
          </OverlayTrigger>
        </>
      );
    }
    if (progress === 100) {
      return (
        <>
          <ProgressBar
            className="requested-bill-progress-bar full"
            min={0}
            max={100}
            now={progress}
            animated={false}
          />
          <p className="requested-bill-item-percentage">{progress}%</p>
          <OverlayTrigger
            placement="top"
            delay={{ show: 50, hide: 400 }}
            overlay={renderInfoTooltip}
          >
            <div className="requested-bill-item-results-container">
              <p className="requested-bill-item-percentage">
                <HiOutlineDocumentDuplicate className="requested-bill-download-icon" />
                x{recoveredBills}
              </p>
              <p className="requested-bill-item-percentage">
                <IoIosTimer className="requested-bill-download-icon" />
                {getTimeElapsed(timeElapsed)}
              </p>
            </div>
          </OverlayTrigger>
        </>
      );
    }

    return (
      <>
        <ProgressBar
          className="requested-bill-progress-bar"
          min={0}
          max={100}
          now={progress}
          animated={true}
        />
        <p className="requested-bill-item-percentage">{progress}%</p>
      </>
    );
  };
  const renderFileIcon = () => {
    return (
      <a
        className="requested-bill-form-link"
        target="_blank"
        rel="noreferrer"
        href={pdfLink}
      >
        <LiaFileDownloadSolid className="requested-bill-download-icon" />
      </a>
    );
  };
  const renderReportErrorIcon = () => {
    if (
      errorMessage !== SERVICE_NAME_NOT_AVALABLE &&
      errorMessage !== RPU_NO_LONGER_AVALABLE &&
      errorMessage !== CONTRACT_DATA_NOT_AVALABLE
    ) {
      return (
        <BiMessageRoundedError
          onClick={() => reportError()}
          className="requested-bill-download-icon"
        />
      );
    }
  };
  const renderActions = () => {
    if (errorMessage !== '') {
      return (
        <td className="requested-bill-table-item one actions">
          <AiOutlineRedo
            onClick={() => retryError()}
            className="requested-bill-download-icon"
          />
          {renderReportErrorIcon()}
        </td>
      );
    }
    if (csvLink !== '') {
      return (
        <td className="requested-bill-table-item one actions">
          <a
            className="requested-bill-form-link"
            target="_blank"
            rel="noreferrer"
            href={csvLink}
          >
            <BsFiletypeCsv className="requested-bill-download-icon" />
          </a>
          {renderFileIcon()}
        </td>
      );
    }
  };
  const renderDatetime = (datetime?: Date) => {
    if (datetime) {
      return (
        datetime.toLocaleDateString() + ' ' + datetime.toLocaleTimeString()
      );
    }
  };
  const renderModalError = () => {
    if (batu.errorMessage === CONTRACT_DATA_NOT_AVALABLE) {
      return (
        <>
          <p className="requested-bill-service-name-needed-popup-title">
            {`${batu.rpu} - 😅 No encontramos el nombre de servicio`}
          </p>
          <p className="requested-bill-service-name-needed-popup-subtitle">
            ¿Lo tienes a la mano? Nos podemos saltar ese paso.
          </p>
          <p className="requested-bill-service-name-needed-popup-subtitle">
            El monto del último recibo es opcional pero sirve para ser más
            precisos.
          </p>
        </>
      );
    }
    if (batu.errorMessage === LATEST_TOTAL_INCORRECT) {
      return (
        <>
          <p className="requested-bill-service-name-needed-popup-title">
            {`${batu.rpu} - El monto del último recibo no coincide`}
          </p>
        </>
      );
    }
    if (batu.errorMessage === SERVICE_NAME_INCORRECT) {
      return (
        <>
          <p className="requested-bill-service-name-needed-popup-title">
            {`${batu.rpu} - El nombre de servicio no coincide`}
          </p>
          <p className="requested-bill-service-name-needed-popup-subtitle">
            Intenta copiar y pegar el nombre, a veces tienen doble espacio. El
            monto del último recibo es opcional pero nos ayuda a ser más
            precisos.
          </p>
        </>
      );
    }
  };
  return (
    <>
      <Modal
        show={showServiceNameModal}
        onHide={() => setShowServiceNameModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="requested-bill-service-name-needed-popup"
        contentClassName="requested-bill-service-name-needed-popup-content"
      >
        <Modal.Body className="requested-bill-service-name-needed-popup-body">
          {renderModalError()}
          <div className="requested-bill-service-name-needed-popup-input-container">
            <BaseInput
              inputLabel="Nombre de Servicio"
              val={serviceName}
              inputPlaceholder="Industrias ACME"
              extraClassContainer="requested-bill-service-name-needed-popup-input"
              inError={variableErrors?.includes('serviceName')}
              onTextChange={(val) => {
                setServiceName(val);
                resetFeedback();
              }}
            />
            <ControlledNumericInput
              inputLabel="Monto del último recibo"
              val={latestTotal.toString()}
              inputPlaceholder="15504.36"
              type="integer"
              validationError={variableErrors?.includes('latestTotal')}
              onError={() => setVariableErrors(['latestTotal'])}
              maxNumber={999999999}
              onTextChange={(val) => {
                setLatestTotal(parseInt(val));
                resetFeedback();
              }}
            />
          </div>
          <p className="requested-bill-service-name-needed-error-message">
            {serviceNameErrorMessage}
          </p>
        </Modal.Body>
        <Modal.Footer className="requested-bill-service-name-needed-popup-footer">
          <FormButton
            content="Reintentar con Nombre"
            disabled={false}
            onSubmit={() => retryWithServiceName(true)}
          />
          <FormButton
            content="Reintentar solo con RPU"
            disabled={false}
            onSubmit={() => {
              retryWithServiceName(false);
            }}
          />
        </Modal.Footer>
      </Modal>
      <tr key="A" className="requested-bill-table-item main">
        <td className="requested-bill-table-item one status">
          {renderStatus(status)}
        </td>
        <td className="requested-bill-table-item two">{batu.rpu}</td>
        <td className="requested-bill-table-item four">{renderProgress()}</td>
        <td className="requested-bill-table-item three date">
          {renderDatetime(batu.datetime)}
        </td>
        <td className="requested-bill-table-item one actions">
          {renderActions()}
        </td>
      </tr>
    </>
  );
};
export { RequestedBill };
